import React from 'react';
import {ArrowRight} from 'lucide-react';
import SiteLink from './SiteLink';
import styles from './styles/SectionTitle.module.css';

interface SectionTitleProps {
    eyebrow: string;
    title: string;
    description: string;
    actionLabel?: string;
    actionTo?: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({
                                                       eyebrow,
                                                       title,
                                                       description,
                                                       actionLabel,
                                                       actionTo
                                                   }) => {
    return (
        <div className={styles.wrap}>
            <div className={styles.copy}>
                <span className="site-eyebrow">{eyebrow}</span>
                <h2 className={styles.title}>{title}</h2>
                <p className={styles.description}>{description}</p>
            </div>
            {actionLabel && actionTo ? (
                <SiteLink className={styles.action} to={actionTo}>
                    <span>{actionLabel}</span>
                    <ArrowRight size={16}/>
                </SiteLink>
            ) : null}
        </div>
    );
};

export default SectionTitle;
